import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Validators } from '@angular/forms';
import { DocumentService } from '@app/shared/services';
import { ToastrService } from 'ngx-toastr';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'ask-password-protected',
  templateUrl: './ask-password-protected.component.html',
  styleUrl: './ask-password-protected.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AskPasswordProtectedComponent implements OnInit, OnDestroy {
  subscription: Subscription = new Subscription();
  askPasswordForm: UntypedFormGroup;
  visibility = false;
  constructor(
    private dialogRef: MatDialogRef<AskPasswordProtectedComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _fb: UntypedFormBuilder,
    private cd: ChangeDetectorRef,
    private documentService: DocumentService,
    private toastr: ToastrService
  ) {}
  ngOnInit(): void {
    this.askPasswordForm = this._fb.group({
      password: ['', [Validators.required]],
    });
  }
  async removePassword() {
    this.subscription.add(
      this.documentService
        .removePassword({
          id: this.data.file.id,
          password: this.askPasswordForm.value.password,
        })
        .subscribe((res) => {
          if (res.status) {
            this.toastr.success('Password removed successfully');
            this.dialogRef.close({
              success: true,
              res: res,
            });
          } else {
            this.askPasswordForm.get('password')?.setErrors({ incorrect: true });
            this.cd.detectChanges();
          }
        })
    );
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
  closeDialog() {
    this.dialogRef.close();
  }
}
